<div class="flex gap-15 align-input-cods">
  @for (digito of codigo; track digito; let index = $index){
    <input
      class="input-codigo"
      type="text"
      maxlength="1"
      [(ngModel)]="codigo[index]"
      (input)="moverFoco($event, index)"
      #inputRef>
  }
</div>
